import { render, staticRenderFns } from "./FileUpload.vue?vue&type=template&id=2dc0c4ee&scoped=true&"
import script from "./FileUpload.vue?vue&type=script&lang=js&"
export * from "./FileUpload.vue?vue&type=script&lang=js&"
import style0 from "./FileUpload.vue?vue&type=style&index=0&id=2dc0c4ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc0c4ee",
  null
  
)

export default component.exports